var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKursWoskowy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Warstwa 1",
    viewBox: "0 0 200 268",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;}.cls-1,.cls-2{stroke:#000;}.cls-1,.cls-2,.cls-3{stroke-miterlimit:10;}.cls-2{fill:#ac893a;}.cls-3{stroke:#ac893a;stroke-width:2.92px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "menu_grafika_woskowy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(23.435)",
    d: "m59.07 0v146.8h34.99v-146.8h-1v145.8h-32.99v-145.8z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.1105 0 0 1.1105 -310.29 11.741)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m369.48 92.498c-37.845-4e-4 -68.525 30.679-68.524 68.524 2e-3 37.844 30.68 68.521 68.524 68.521 37.842-2e-3 68.519-30.678 68.521-68.521 4e-4 -37.844-30.677-68.523-68.521-68.524zm15.724 60.56c6e-3 -2.2982-2.4119-10.416-2.3583-12.589 0.13519-5.4698 3.6361-9.6536 5.8426-8.0688 7.3264 6.7783 2.8118 11.842 5.2918 17.615 2.8299 3.2486 8.2456-0.317 9.4622-3.1534 1.9736 0.77606 2.3353 10.977 2.3351 14.16-6e-4 20.046-16.251 36.297-36.298 36.298-20.048 1e-3 -36.301-16.25-36.301-36.298-6e-4 -9.2631 1.6167-17.901 7.3269-24.315 1.7939-2.015 5.2966-5.9735 8.2043-7.9687 1.9776-1.357 4.7276-1.8058 4.3823-0.11787-1.9491 9.5308 11.766 8.2237 12.831 0.58272 0.2211-1.5863 3.6382 1.4358 4.7622 3.0091 1.2911 1.8072 2.3972 4.9815 2.804 8.4657 0.22443 1.9208-1.0557 10.85-0.84219 12.952 1.4661 8.4224 12.46 7.596 12.557-0.57141z",
    color: "#000000",
    fill: "#ac893a",
    strokeWidth: 0.98564,
    style: {
      InkscapeStroke: "none",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m369.49 92.003c-38.111-4e-4 -69.017 30.906-69.017 69.017 2e-3 38.11 30.907 69.017 69.017 69.017 38.109-2e-3 69.002-30.908 69.004-69.017 4e-4 -38.11-30.894-69.015-69.004-69.017zm0 0.98851c37.577 2e-3 68.029 30.451 68.028 68.028-2e-3 37.576-30.452 68.027-68.028 68.028-37.577 4e-4 -68.04-30.451-68.041-68.028-4e-4 -37.579 30.463-68.029 68.041-68.028z",
    color: "#000000",
    strokeWidth: 6.6598,
    style: {
      InkscapeStroke: "none",
      paintOrder: "markers fill stroke"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKursWoskowy);
export default __webpack_public_path__ + "static/media/kurs_woskowy.3ed74c7eb86967eea91d36d7fb5ebfc9.svg";
export { ForwardRef as ReactComponent };